// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fieldwork_container_fieldwork__gy7Pi {
    display: flex;
    flex:  5 1;
    flex-direction: column;
    align-items: flex-start;
    align-content: baseline;
    justify-content: center;
    background-color: var(--hsrcBackgroundLight);
    border-radius: 1rem;
    padding: 2rem;
}

.fieldwork_featuredDropDown__PqHF1 {
    flex: 1 1;
    margin: 0px 20px;
    padding: 30px;
    border-radius: 10px;
    cursor: default;

}

.fieldwork_featuredItem__iVWKe {
    flex: 1 1;
    margin: 0px 20px;
    padding: 30px;
    border-radius: 10px;
    cursor: default;

}

.fieldwork_featured__wYviJ {
    width: 100%;
    display: flex;
    flex: 1 1; 
    flex-direction: row;
    justify-content: space-between;
}

.fieldwork_featuredTitleHeader__-JhUD {
    color: var(--hsrcDarkBlue);
    font-size: 15px;
    font-weight: bold;
}

.fieldwork_container_row__v4YMe {
    display: flex;
    flex: 1 1;
    justify-content: space-between;
    flex-direction: column;
    align-content: center;
    align-items: center;
    align-self: center;
}

.fieldwork_printviewDialog__\\+m9Bs {
    min-width: 90vw !important;
    max-width: 90vw !important;
}

.fieldwork_confirmDialogOverlay__DNTep {
    z-index: 10000;
    pointer-events: none;
}

.fieldwork_logicalErrorsDialog__k41Uo {
    min-width: 35vw !important;
    max-width: 35vw !important;
    height: 90%;
}

.fieldwork_interactionDialog__cHMkD {
    min-width: 40vw !important;
    max-width: 40vw !important;
    height: 90%;
}

.fieldwork_interactionHistoryDialog__CluAW {
    min-width: 75vw !important;
    max-width: 75vw !important;
    min-height: 85%;
    max-height: 90%;
}

.fieldwork_sectorViewDialog__WEBAv {
    min-width: 80vw !important;
    max-width: 80vw !important;
    min-height: 90%;
    max-height: 90%;
}

.fieldwork_reporting_overview_container__3PewI {
    display: flex;
    flex:  5 1;
    flex-direction: column;
    align-items: flex-start;
    align-content: center;
    justify-content: center;
    background-color: var(--hsrcBackgroundLight);
    border-radius: 1rem;
    padding: 2rem;
    /* min-width: 82%;
    max-width: 82%; */
}

.fieldwork_flex_row_container__c0V2B {
    display: flex;
    flex: 1 1; 
  
    flex-direction: column;
    align-content: center;
    align-items: flex-start;
    align-content: flex-start;
    justify-content: space-around;
  }


.fieldwork_widget_container__qER4L {
    max-width: 40%;
    min-height: 40%;
    max-height: 50%;
}

`, "",{"version":3,"sources":["webpack://./src/pages/ResearcherDashboard/pages/Fieldwork/fieldwork.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,UAAQ;IACR,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,4CAA4C;IAC5C,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,eAAe;;AAEnB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,eAAe;;AAEnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,SAAO;IACP,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,SAAO;IACP,8BAA8B;IAC9B,sBAAsB;IACtB,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,0BAA0B;IAC1B,0BAA0B;IAC1B,WAAW;AACf;;AAEA;IACI,0BAA0B;IAC1B,0BAA0B;IAC1B,WAAW;AACf;;AAEA;IACI,0BAA0B;IAC1B,0BAA0B;IAC1B,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,0BAA0B;IAC1B,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,UAAQ;IACR,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;IACrB,uBAAuB;IACvB,4CAA4C;IAC5C,mBAAmB;IACnB,aAAa;IACb;qBACiB;AACrB;;AAEA;IACI,aAAa;IACb,SAAO;;IAEP,sBAAsB;IACtB,qBAAqB;IACrB,uBAAuB;IACvB,yBAAyB;IACzB,6BAA6B;EAC/B;;;AAGF;IACI,cAAc;IACd,eAAe;IACf,eAAe;AACnB","sourcesContent":[".container_fieldwork {\r\n    display: flex;\r\n    flex:  5;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    align-content: baseline;\r\n    justify-content: center;\r\n    background-color: var(--hsrcBackgroundLight);\r\n    border-radius: 1rem;\r\n    padding: 2rem;\r\n}\r\n\r\n.featuredDropDown {\r\n    flex: 1;\r\n    margin: 0px 20px;\r\n    padding: 30px;\r\n    border-radius: 10px;\r\n    cursor: default;\r\n\r\n}\r\n\r\n.featuredItem {\r\n    flex: 1;\r\n    margin: 0px 20px;\r\n    padding: 30px;\r\n    border-radius: 10px;\r\n    cursor: default;\r\n\r\n}\r\n\r\n.featured {\r\n    width: 100%;\r\n    display: flex;\r\n    flex: 1; \r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n}\r\n\r\n.featuredTitleHeader {\r\n    color: var(--hsrcDarkBlue);\r\n    font-size: 15px;\r\n    font-weight: bold;\r\n}\r\n\r\n.container_row {\r\n    display: flex;\r\n    flex: 1;\r\n    justify-content: space-between;\r\n    flex-direction: column;\r\n    align-content: center;\r\n    align-items: center;\r\n    align-self: center;\r\n}\r\n\r\n.printviewDialog {\r\n    min-width: 90vw !important;\r\n    max-width: 90vw !important;\r\n}\r\n\r\n.confirmDialogOverlay {\r\n    z-index: 10000;\r\n    pointer-events: none;\r\n}\r\n\r\n.logicalErrorsDialog {\r\n    min-width: 35vw !important;\r\n    max-width: 35vw !important;\r\n    height: 90%;\r\n}\r\n\r\n.interactionDialog {\r\n    min-width: 40vw !important;\r\n    max-width: 40vw !important;\r\n    height: 90%;\r\n}\r\n\r\n.interactionHistoryDialog {\r\n    min-width: 75vw !important;\r\n    max-width: 75vw !important;\r\n    min-height: 85%;\r\n    max-height: 90%;\r\n}\r\n\r\n.sectorViewDialog {\r\n    min-width: 80vw !important;\r\n    max-width: 80vw !important;\r\n    min-height: 90%;\r\n    max-height: 90%;\r\n}\r\n\r\n.reporting_overview_container {\r\n    display: flex;\r\n    flex:  5;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    align-content: center;\r\n    justify-content: center;\r\n    background-color: var(--hsrcBackgroundLight);\r\n    border-radius: 1rem;\r\n    padding: 2rem;\r\n    /* min-width: 82%;\r\n    max-width: 82%; */\r\n}\r\n\r\n.flex_row_container {\r\n    display: flex;\r\n    flex: 1; \r\n  \r\n    flex-direction: column;\r\n    align-content: center;\r\n    align-items: flex-start;\r\n    align-content: flex-start;\r\n    justify-content: space-around;\r\n  }\r\n\r\n\r\n.widget_container {\r\n    max-width: 40%;\r\n    min-height: 40%;\r\n    max-height: 50%;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container_fieldwork": `fieldwork_container_fieldwork__gy7Pi`,
	"featuredDropDown": `fieldwork_featuredDropDown__PqHF1`,
	"featuredItem": `fieldwork_featuredItem__iVWKe`,
	"featured": `fieldwork_featured__wYviJ`,
	"featuredTitleHeader": `fieldwork_featuredTitleHeader__-JhUD`,
	"container_row": `fieldwork_container_row__v4YMe`,
	"printviewDialog": `fieldwork_printviewDialog__+m9Bs`,
	"confirmDialogOverlay": `fieldwork_confirmDialogOverlay__DNTep`,
	"logicalErrorsDialog": `fieldwork_logicalErrorsDialog__k41Uo`,
	"interactionDialog": `fieldwork_interactionDialog__cHMkD`,
	"interactionHistoryDialog": `fieldwork_interactionHistoryDialog__CluAW`,
	"sectorViewDialog": `fieldwork_sectorViewDialog__WEBAv`,
	"reporting_overview_container": `fieldwork_reporting_overview_container__3PewI`,
	"flex_row_container": `fieldwork_flex_row_container__c0V2B`,
	"widget_container": `fieldwork_widget_container__qER4L`
};
export default ___CSS_LOADER_EXPORT___;
